(function () {
  'use strict';
  if (window.__gorgiasDefer && window.__gorgiasDefer._booted) return;

  var IDLE_MS = 4000;
  // Gorgias chat + Gorgias Convert (content.9gtb.com) — Convert injects via app block
  var GORGIAS_RE = /gorgias\.(chat|help)|assets\.gorgias\.chat|config\.gorgias|content\.9gtb\.com|9gtb\.com/i;
  var released = false;
  var pending = [];
  var pendingConvert = [];
  var openWhenReady = false;

  window.__gorgiasDefer = {
    _booted: true,
    loaded: false,
    load: function (open) {
      release(!!open);
    }
  };

  function urlOf(node) {
    return (node && (node.src || node.href)) || '';
  }

  function isConvertUrl(url) {
    return /9gtb\.com/i.test(url || '');
  }

  function isGorgiasNode(node) {
    if (!node || node.nodeType !== 1) return false;
    var tag = node.tagName;
    if (tag !== 'SCRIPT' && tag !== 'LINK') return false;
    if (GORGIAS_RE.test(urlOf(node))) return true;
    if (tag === 'SCRIPT' && node.getAttribute && node.getAttribute('data-gorgias-loader-convert') != null) {
      return true;
    }
    if (tag === 'SCRIPT' && !node.src && /gorgias|9gtb/i.test(node.textContent || '')) return true;
    return false;
  }

  function stash(node) {
    if (!node || (node.dataset && node.dataset.gorgiasDeferred === '1')) return;
    var info = {
      tag: node.tagName,
      src: node.src || '',
      href: node.href || '',
      id: node.id || '',
      async: !!node.async,
      defer: !!node.defer,
      rel: node.rel || '',
      text: node.tagName === 'SCRIPT' && !node.src ? node.textContent : '',
      convert:
        isConvertUrl(node.src || node.href || '') ||
        (node.getAttribute && node.getAttribute('data-gorgias-loader-convert') != null)
    };
    if (info.convert) pendingConvert.push(info);
    else pending.push(info);
    try {
      if (node.tagName === 'SCRIPT') {
        node.type = 'text/plain';
        if (node.dataset) node.dataset.gorgiasDeferred = '1';
        node.removeAttribute('src');
      }
      if (node.parentNode) node.parentNode.removeChild(node);
    } catch (e) {}
  }

  function patch(proto, name) {
    var orig = proto[name];
    if (!orig || orig.__gorgiasDefer) return;
    var wrapped = function () {
      var node = arguments[0];
      if (!released && isGorgiasNode(node)) {
        stash(node);
        return node;
      }
      return orig.apply(this, arguments);
    };
    wrapped.__gorgiasDefer = true;
    proto[name] = wrapped;
  }

  patch(Node.prototype, 'appendChild');
  patch(Node.prototype, 'insertBefore');

  var mo = new MutationObserver(function (mutations) {
    if (released) return;
    for (var i = 0; i < mutations.length; i++) {
      var nodes = mutations[i].addedNodes;
      for (var j = 0; j < nodes.length; j++) {
        var n = nodes[j];
        if (isGorgiasNode(n)) {
          stash(n);
          continue;
        }
        if (n.nodeType === 1 && n.querySelectorAll) {
          var found = n.querySelectorAll(
            'script[src*="gorgias"],link[href*="gorgias"],script[src*="bundle-loader/shopify"],script[src*="9gtb.com"],script[data-gorgias-loader-convert]'
          );
          for (var k = 0; k < found.length; k++) {
            if (isGorgiasNode(found[k]) || /bundle-loader\/shopify/i.test(urlOf(found[k]))) {
              stash(found[k]);
            }
          }
        }
      }
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  function inject(info) {
    if (info.tag === 'LINK') {
      var link = document.createElement('link');
      if (info.rel) link.rel = info.rel;
      if (info.href) link.href = info.href;
      (document.head || document.documentElement).appendChild(link);
      return;
    }
    var script = document.createElement('script');
    if (info.id) script.id = info.id;
    if (info.text) {
      script.textContent = info.text;
    } else if (info.src) {
      script.src = info.src;
      if (info.async) script.async = true;
      if (info.defer) script.defer = true;
      // Avoid uncaught network noise if Convert CDN flakes (QUIC errors)
      script.onerror = function () {};
    }
    (document.head || document.documentElement).appendChild(script);
  }

  function tryOpen() {
    var ready = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener(
            'gorgias-widget-loaded',
            function () {
              resolve();
            },
            { once: true }
          );
        });
    Promise.resolve(ready).then(function () {
      try {
        if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
          window.GorgiasChat.open();
        }
      } catch (e) {}
    });
  }

  function flushConvert() {
    var items = pendingConvert.slice();
    pendingConvert = [];
    for (var i = 0; i < items.length; i++) inject(items[i]);
  }

  function release(open) {
    if (open) openWhenReady = true;
    if (released) {
      // Chat already released; Convert still waits for interaction / open
      if (open) flushConvert();
      if (openWhenReady) tryOpen();
      return;
    }
    released = true;
    try {
      mo.disconnect();
    } catch (e) {}

    var items = pending.slice();
    pending = [];
    for (var i = 0; i < items.length; i++) inject(items[i]);

    // Idle release loads chat only; Convert waits for interaction (avoids LH 9gtb network errors)
    if (open) flushConvert();

    window.__gorgiasDefer.loaded = true;
    if (openWhenReady) tryOpen();
  }

  function onInteract() {
    release(false);
    flushConvert();
  }

  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (ev) {
    window.addEventListener(ev, onInteract, { once: true, passive: true, capture: true });
  });

  setTimeout(function () {
    release(false);
  }, IDLE_MS);

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest
        ? e.target.closest(
            '[data-gorgias-open], [data-defer-gorgias], .js-gorgias-chat, a[href="#chat"], a[href="#gorgias-chat"]'
          )
        : null;
      if (!btn) return;
      if (btn.tagName === 'A') e.preventDefault();
      release(true);
    },
    true
  );
})();
